import { render, staticRenderFns } from "./CoinsBalancePopup.vue?vue&type=template&id=a945fae6&scoped=true&"
import script from "./CoinsBalancePopup.vue?vue&type=script&lang=js&"
export * from "./CoinsBalancePopup.vue?vue&type=script&lang=js&"
import style0 from "./CoinsBalancePopup.vue?vue&type=style&index=0&id=a945fae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a945fae6",
  null
  
)

export default component.exports